import React from 'react';

import styled from 'styled-components';

import { CommunityContractBenefit } from 'types/contracts';
import { raiseUnderscore } from 'utils/helpers/string';

import Header from '../../common/header/Header';
import { useCommunityInfoContext } from '../../CommunityInfoContext';
import { useCareTypesContext } from '../CareTypesContext';

const Container = styled.div`
  position: relative;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

const CategoryTitle = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-bold);
  font-size: 12px;
  margin-bottom: 10px;
`;

const BenefitGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Benefit = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
`;

const ContractBenefits = () => {
  const { contractBenefits } = useCommunityInfoContext();
  const { contract } = useCareTypesContext();

  const filteredBenefits = contractBenefits?.filter((item) => item.contract_id === contract?.contract_id) || [];

  const groupedByCategory = filteredBenefits.reduce(
    (acc, benefit) => {
      const categoryId = benefit.category_id ?? 0;
      if (!acc[categoryId]) {
        acc[categoryId] = {
          categoryName: benefit.category_name,
          benefits: [],
        };
      }
      acc[categoryId].benefits.push(benefit);
      return acc;
    },
    {} as Record<number, { categoryName: string; benefits: CommunityContractBenefit[] }>
  );

  return (
    <Container>
      <Header title="Contract Benefits" />
      <Content>
        {Object.entries(groupedByCategory)
          .sort(([a], [b]) => Number(a) - Number(b))
          .map(([categoryId, group]) => (
            <div key={categoryId}>
              <CategoryTitle
                data-test-id={`cd-contract-benefit-benefit-${raiseUnderscore(group.categoryName).toLowerCase()}`}
              >
                {group.categoryName}
              </CategoryTitle>
              <BenefitGroup>
                {group.benefits.map((item, index) => (
                  <Benefit data-test-id={`cd-contract-benefit-benefit-${index + 1}`} key={item.id}>
                    - {item.benefit}
                  </Benefit>
                ))}
              </BenefitGroup>
            </div>
          ))}
      </Content>
    </Container>
  );
};

export default ContractBenefits;
